"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const locale_1 = require("date-fns/locale");
const locales = { 'en-GB': locale_1.enGB, 'en-US': locale_1.enUS, it: locale_1.it };
const formatter = (value, format, lng, options, extraFormatter) => {
    let result;
    if (extraFormatter) {
        result = extraFormatter(value, format, lng, options);
    }
    if (!result && (0, date_fns_1.isDate)(value) && format && lng) {
        const currentLang = lng.includes('en') ? 'en' : lng;
        const locale = locales[currentLang];
        if (format === 'bookingTicket')
            return (0, date_fns_1.format)(value, 'dd MMM. yyyy', { locale }).toLowerCase();
        if (format === 'currentFullDate')
            return (0, date_fns_1.format)(value, 'dd MMMM yyyy, EEEE', {
                locale,
            });
        if (format === 'multiDays')
            return (0, date_fns_1.format)(value, 'dd MMM.', { locale }).toLowerCase();
        if (format === 'noticeDate')
            return (0, date_fns_1.format)(value, 'dd MMMM', {
                locale,
            }).toLowerCase();
        if (format === 'noticeDetails')
            return (0, date_fns_1.format)(value, "dd'.'MM'.'yyyy'", { locale });
        if (format === 'notification') {
            return (0, date_fns_1.format)(value, 'P', {
                locale,
            });
        }
        if (format === 'notificationDetails') {
            return (0, date_fns_1.format)(value, 'dd MMMM yyyy', {
                locale,
            }).toLowerCase();
        }
    }
    return value;
};
exports.default = formatter;
